import React, { useState, useEffect } from "react";
import "./Infrastructure.css";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

// IMAGES
import smartImg from "../assets/smart-class.JPG";
import sciImg from "../assets/science_lab.png";
import mathImg from "../assets/maths_lab.png";
import compImg from "../assets/computer_lab.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFutbol,
  faBus,
  faComputer,
  faLightbulb,
  faCalendar,
  faChalkboardTeacher,
  faPalette,
  faBookOpen,
  faGamepad
} from "@fortawesome/free-solid-svg-icons";

export default function Infrastructure() {
  const [flippedIndex, setFlippedIndex] = useState(null);

  const handleFlip = (index) => {
    setFlippedIndex(flippedIndex === index ? null : index);
  };

  // AOS REFRESH
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <div className="infrastructure-page">

      {/* HERO SECTION */}
      <section className="infra-hero" data-aos="fade-up">
        <h1 className="infra-title">
          Building Bright Futures Through World Class Infrastructure
        </h1>
        <p className="infra-subtitle">
          At Lotus Lap School, our campus is thoughtfully designed to inspire
          learning, creativity, and growth. Every space reflects our commitment
          to providing a safe, modern, and engaging environment for young minds.
          From smart classrooms to vibrant activity areas, we ensure students
          experience education beyond textbooks while fostering innovation,
          collaboration, and holistic development every single day.
        </p>
      </section>

      {/* INFRASTRUCTURE SECTIONS */}
      
<section className="infra-sections">

  {/* ROW 1 */}
  <div className="infra-row">
    <div className="infra-image" data-aos="fade-right">
      <img src={smartImg} alt="Smart Classrooms" />
    </div>
    <div className="infra-text" data-aos="fade-left">
      <h3 className="infra-side-heading">Smart Classrooms</h3>
      <p>
        Our smart classrooms integrate advanced digital tools, interactive boards,
        and multimedia resources to create an engaging learning environment.
        Lessons are designed to be visually dynamic, helping students grasp complex
        concepts with ease. This technology driven approach encourages participation,
        improves retention, and makes learning both effective and enjoyable.
      </p>
    </div>
  </div>

  {/* ROW 2 → NOW SCIENCE LAB */}
  <div className="infra-row reverse">
    <div className="infra-image" data-aos="fade-left">
      <img src={sciImg} alt="Science Lab" />
    </div>
    <div className="infra-text" data-aos="fade-right">
      <h3 className="infra-side-heading">Science Lab</h3>
      <p>
        Our science lab is fully equipped with modern apparatus and safety measures,
        allowing students to perform experiments and gain hands-on experience.
        Practical learning helps bridge the gap between theory and application,
        fostering curiosity and a deeper understanding of scientific principles.
      </p>
    </div>
  </div>

  {/* ROW 3 */}
  <div className="infra-row">
    <div className="infra-image" data-aos="fade-right">
      <img src={mathImg} alt="Math Lab" />
    </div>
    <div className="infra-text" data-aos="fade-left">
      <h3 className="infra-side-heading">Math Lab</h3>
      <p>
        The math lab transforms numbers into engaging activities through models,
        puzzles, and visual demonstrations. Students learn mathematical concepts
        through interactive methods, making problem solving intuitive and enjoyable
        while building a strong conceptual foundation.
      </p>
    </div>
  </div>

  {/* ROW 4 */}
  <div className="infra-row reverse">
    <div className="infra-image" data-aos="fade-left">
      <img src={compImg} alt="Computer Lab" />
    </div>
    <div className="infra-text" data-aos="fade-right">
      <h3 className="infra-side-heading">Computer Lab</h3>
      <p>
        Our computer lab features up to date systems with high speed internet access,
        enabling students to develop essential digital skills. From basic computing
        to advanced applications, students are trained to adapt to the evolving
        technological landscape with confidence and creativity.
      </p>
    </div>
  </div>

</section>

      {/* FACILITIES */}
      <section className="facilities-section" data-aos="fade-up">
        <h2 className="facilities-title">Our Facilities</h2>
        <p className="facilities-subtitle">
          We provide a vibrant and supportive environment where students grow
          academically, creatively, and socially.
        </p>

        <div className="facilities-grid">

   {[
  { icon: faFutbol, title: "Sports Facilities", desc: "Encouraging physical fitness and teamwork through sports.", color: "sports" },
  { icon: faBus, title: "Transportation", desc: "Safe and reliable transport for all students.", color: "transport" },
  { icon: faComputer, title: "Computer Education", desc: "Building strong digital and technical skills.", color: "computer" },
  { icon: faLightbulb, title: "Creative Ideas", desc: "Fostering innovation and imagination.", color: "creative" },
  { icon: faCalendar, title: "Events & Programs", desc: "Regular activities to enhance exposure.", color: "events" },
  { icon: faChalkboardTeacher, title: "Good Faculty", desc: "Experienced and caring teachers.", color: "faculty" },
  { icon: faPalette, title: "Colorful Classes", desc: "Vibrant spaces for joyful learning.", color: "colorful" },
  { icon: faBookOpen, title: "Positive Learning", desc: "Supportive and motivating environment.", color: "learning" },
  { icon: faGamepad, title: "Fun With Games", desc: "Learning through fun and engagement.", color: "games" }
].map((item, index) => (
  <div
    className={`flip-card fade-in ${item.color} ${
      flippedIndex === index ? "flipped" : ""
    }`}
    key={index}
    onClick={() => handleFlip(index)}
    data-aos="zoom-in"
    data-aos-delay={index * 100}
  >
    <div className="flip-card-inner">

      <div className="flip-card-front">
        <FontAwesomeIcon icon={item.icon} className="facility-icon" />
        <h3>{item.title}</h3>
      </div>

      <div className="flip-card-back">
        <p>{item.desc}</p>
      </div>

    </div>
  </div>
))}

        </div>
      </section>


    </div>
  );
}